import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { colors } from '../../constants'

const Wrapper = styled.div`
    overflow: hidden;
    ${({ noRelative }) => !noRelative && `position: relative;`}
    width: fit-content;
    display: inline-block;
    padding-right: 2px;

    &:before {
        color: grey;
        content: '\f002';
        font-family: 'Font Awesome 5 Free';
        font-size: 12px;
        font-weight: 900;
        left: 10px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
`

const Search = styled.input`
    background: ${colors.white};
    border: 1px solid #cccccc;
    border-radius: 5px;
    color: ${colors.greydark};
    font-size: 13px;
    outline: none;
    padding: 10px 30px;
    vertical-align: middle;
    transition: 0.3s all;
    ${({ fullwidth }) => fullwidth && 'width: 100%;'}
    ${({ width }) => width && `width: ${width};`}

    &:active,
    &:focus {
        border: 1px solid ${colors.grey};
    }

    &::placeholder {
        font-size: 12px;
    }
`

/**
 * 
 * @param {object} props
 * @param {string} [props.borderColor]
 * @param {boolean} [props.fullwidth]
 * @param {string} [props.name]
 * @param {boolean} [props.noRelative]
 * @param {function} [props.onBlur]
 * @param {function} [props.onChange]
 * @param {function} [props.onKeyPress]
 * @param {function} [props.onFocus]
 * @param {string} [props.placeholder] 
 * @param {string} [props.value]
 * @param {string} [props.width]
 * @returns 
 */
function SearchInput({
    foo,
    borderColor,
    fullwidth,
    name,
    noRelative,
    onBlur,
    onChange,
    onFocus,
    value,
    ph,
    ...rest
}) {
    const { t } = useTranslation();

    return (
        <Wrapper noRelative={noRelative}>
            <Search
                id={name}
                name={name}
                borderColor={borderColor}
                fullwidth={fullwidth}
                noRelative={noRelative}
                onBlur={onBlur}
                onChange={onChange}
                onFocus={onFocus}
                placeholder={ph ?? `${t('Search')}...`}
                type="text"
                value={value}
                {...rest}
            />
        </Wrapper>
    );
}

SearchInput.propTypes = {
    borderColor: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    fullwidth: PropTypes.bool,
    name: PropTypes.string,
    noRelative: PropTypes.bool,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.string,
    ph: PropTypes.string,
}

SearchInput.defaultProps = {
    borderColor: colors.white,
    fullwidth: false,
    name: 'search',
    noRelative: false,
    onBlur: () => {},
    onChange: () => {},
    onFocus: () => {},
    value: '',
}

export default SearchInput
